module.exports = __webpack_public_path__ + "static/media/file.1c66f01d.pdf";